import { useImageAnnotatorContext } from "@msuite/image-annotator";
import type { PolygonAnnotation } from "@msuite/utils/types";
import { AnnotationColorSwatch } from "./annotation-color-swatch";

export function AnnotationToolbarSubMenuFill() {
	/** Context */
	const context = useImageAnnotatorContext();
	const selectedAnnotation = context.controller.getSelectedAnnotation() as PolygonAnnotation;

	/** Guard */
	if (!selectedAnnotation) return null;

	/** Render */
	return (
		<AnnotationColorSwatch
			value={selectedAnnotation.fillColor}
			onChange={(value) => context.controller.handleOnUpdateSelection({ fillColor: value })}
			withAlpha
		/>
	);
}
